<template>
  <ul class="public-list">
    <!-- 资讯列表页 -->
    <li class="sol-list-item" v-for="(item, index) in params.list" :key="index" v-if="params.type=='info'">
      <div class="sol-new-public" @click="toNewsDetail(item.columnId)">
          <div class="sol-new-top">
            <div class="sol-new-top-left">
                <div class="sol-new-title">{{item.columnTitle}}</div>
                <div class="sol-new-bottom">
                    <div>{{item.pageView}}阅读量</div>
                     <div style="display:flex">
                        <span>{{
                          item.createTime && item.createTime.split(" ")[0]
                        }}</span>
                    </div>
                </div>
            </div>
            <div class="sol-new-top-right">
              <img :src="item.matchPic | getImageUrl">
            </div>
          </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { textSlice, myriabit, getImageUrl } from '@/filters/commonFilters'
export default {
  name: 'list',
  props: ['params'],
  filters: {
    textSlice,
    myriabit,
    getImageUrl
  },
  methods: {
    // 方案详情
    jumpDetail (item) {
      this.$router.push(`/solutions/detail/${item.solutionId}.html`)
    },
    // 资讯详情
    toNewsDetail (id) {
      this.$router.push(`/news/detail/${id}.html`)
    }
  }
}
</script>

<style scoped lang="scss">

 @mixin TwoLine {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.public-list {
  background-color: #fff;
  .sol-list-item {
    padding: 12px 0;
    margin: 0 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    .sol-new-public {
      .sol-new-top {
        display: flex;
        justify-content: space-between;
        color: #222;

        &-left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
            .sol-new-title {
                width: 217px;
                font-size: 15px;
                white-space: normal;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                line-height: 23px;
                word-wrap:break-word;
                color: rgba(0,0,0,0.65);
                font-weight: bold;
            }
        }
        &-right {
          width: 110px;
          height: 75px;
          flex: 0 0 auto;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      .sol-new-bottom {
          display: flex;
          align-items: center;
          line-height: 1;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0,0,0,0.45);
          & div:nth-of-type(1) {
            margin-right: 4px;
          }
      }
    }
    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newList.vue